<div class="input-wrapper" [formGroup]="formGroup" [class.disabled]="disabled"
    [class.input-error]="showErrorMessages && f[controlName].invalid && f[controlName].touched" [class.arebic-content]="textDirection == 'rtl'">
    <span class="p-float-label p-input-icon-right">
        <p-dropdown class="taly-select" [options]="options" [placeholder]="placeholderText" #inputField
            [formControlName]="controlName" (change)="onChange(inputField.value)" [disabled]="disabled"
            [optionLabel]="optionsLabel" [inputId]="id" [autoDisplayFirst]="false" (onHide)="onHide(inputField.value)">
       
            <ng-template let-item  pTemplate="selectedItem" >

               {{item[optionsLabel]}} 
            </ng-template>

            <ng-template let-item pTemplate="item">
                {{item[optionsLabel]}} 
            </ng-template>

        </p-dropdown>
        <label [htmlFor]="id">{{ label | translate }}</label>
        <!-- <ng-container *ngIf="!disabled">
            <i class="pi pi-times" (click)="onReset(inputField)" *ngIf="inputField.value"></i>
        </ng-container> -->
    </span>
</div>
<div *ngIf="showErrorMessages && f[controlName].invalid && f[controlName].touched" class="alert">
    <span class="alert-danger" *ngIf="f[controlName].hasError('required')">
        {{label  | translate }} <span class="alert-danger" translate>COMMON.REQUIRED</span>
    </span>
    <span class="alert-danger" *ngIf="f[controlName]?.hasError('minlength')">
        <span class="alert-danger" translate>COMMON.MIN_LENGTH</span> {{label}}
    </span>
    <span class="alert-danger" *ngIf="f[controlName]?.hasError('maxlength')">
        <span class="alert-danger" translate>COMMON.MAX_LENGTH</span> {{label}}
    </span>
    <span class="alert-danger" *ngIf="f[controlName]?.hasError('email')">
        COMMON.INVALID_EMAIL
    </span>
    <span class="alert-danger" *ngIf="f[controlName]?.hasError('pattern')">
        COMMON.INALID_FORMAT
    </span>
</div>